import { motion } from "framer-motion";
import { Globe, LayoutTemplate, RefreshCw, Smartphone, Search, Mail } from "lucide-react";

const services = [
  { icon: Globe, title: "Business Websites", desc: "Complete, polished sites that establish credibility and win trust." },
  { icon: LayoutTemplate, title: "Landing Pages", desc: "Focused, high-converting pages built to turn visitors into leads." },
  { icon: RefreshCw, title: "Website Redesign", desc: "Modern makeovers that breathe new life into dated websites." },
  { icon: Smartphone, title: "Mobile Optimization", desc: "Flawless, fast experiences on every screen size and device." },
  { icon: Search, title: "SEO Ready", desc: "Clean, structured foundations that help you rank and get found." },
  { icon: Mail, title: "Contact Forms", desc: "Seamless enquiry forms that connect customers straight to you." },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="mb-16 max-w-2xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[#d4af37]" />
            <span className="text-xs uppercase tracking-[0.3em] gold-text">What I Offer</span>
          </div>
          <h2 className="font-serif-display font-light text-4xl md:text-6xl tracking-tight">
            Services crafted to <span className="italic gold-text">elevate</span> your brand
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="group relative bg-[#0a0a09] p-9 md:p-11 hover:bg-[#111110] transition-colors duration-500"
            >
              <div className="mb-8 inline-flex items-center justify-center w-14 h-14 rounded-2xl border border-white/10 text-white/70 group-hover:border-[#d4af37] group-hover:text-[#d4af37] transition-colors duration-500">
                <s.icon size={24} strokeWidth={1.3} />
              </div>
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-serif-display text-2xl md:text-3xl mb-3">{s.title}</h3>
                <span className="font-serif-display text-sm text-white/20 group-hover:text-[#d4af37] transition-colors duration-500">
                  0{i + 1}
                </span>
              </div>
              <p className="text-white/50 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
